export class SearchFieldInfo {
    constructor(
        public readonly fieldName: string,
        public readonly fieldValue: string
    ) { }
}